import { LitElement, html } from "lit-element";
import WebMidi from "webmidi";
import { scale } from "../utils/utils";
const Color = require("color"); // switch to import?

class RhythmicColor extends LitElement {
  static get properties() {
    return {
      source: { type: String },
      width: { type: String },
      height: { type: String },
      widthDivision: { type: Number },
      heightDivision: { type: Number },
      left: { type: String },
      top: { type: String },
      bottom: { type: String },
      right: { type: String },
      offset: { type: Number },
      position: { type: String },
      lowNote: { type: Number },
      highNote: { type: Number },
      mixBlendMode: { type: String },
      ccResponsive: { type: Boolean },
      knobOneNumber: { type: Number },
      knobTwoNumber: { type: Number },
      knobThreeNumber: { type: Number },
      knobFourNumber: { type: Number },
      knobOneValue: { type: Number },
      knobTwoValue: { type: Number },
      knobThreeValue: { type: Number },
      knobFourValue: { type: Number },
      debug: { type: Boolean },
      url: { type: String },
      orientation: { type: String },
      startFrom: { type: String },
      numNotes: { type: Number },
      startColor: { type: String },
      endColor: { type: String },
      startFadeAfterMilliseconds: { type: Number },
      backgroundColor: { type: String },
      transitionDuration: { type: String },
      opacity: { type: Number },
      opacityCC: { type: Number },
      ccSource: { type: String },
      backgroundOpacity: { type: Number },
      boxShadow: { type: String },
      borderRadius: { type: String },
      noteOpacity: { type: String },
    };
  }

  constructor() {
    super();

    this.source = "IAC Driver Bus 1";
    this.container = null;
    this.width = null;
    this.height = null;
    this.widthDivision = 1;
    this.heightDivision = 1;
    this.left = "0%";
    this.top = "0%";
    this.bottom = null;
    this.fill = false;
    this.lowNote = 21;
    this.highNote = 108;
    this.mixBlendMode = "normal";
    this.position = "relative";
    this.knobOneNumber = null;
    this.knobTwoNumber = null;
    this.knobThreeNumber = null;
    this.knobFourNumber = null;
    this.knobOneValue = 0;
    this.knobTwoValue = 0;
    this.knobThreeValue = 0;
    this.knobFourValue = 0;
    this.ccResponsive = false;
    this.backgroundColor = "rgb(0, 0, 0";
    this.debug = false;
    this.url = "";
    this.activeNotes = [];
    this.orientation = "vertical";
    this.startFrom = "top";
    this.offset = 0;
    this.noteCount = 0;
    this.numNotes = 4;
    this.startColor = "rgb(255, 0, 0)";
    this.endColor = "rgb(255, 255, 0)";
    this.startFadeAfterMilliseconds = 0;
    this.backgroundColor = "white";
    this.transitionDuration = ".2s";
    this.opacity = 1;
    this.opacityCC;
    this.ccSource = "Arturia MINILAB";
    this.backgroundOpacity = 1;
    this.boxShadow = "none";
    this.borderRadius = "none";
    this.noteOpacity;

    WebMidi.enable((error) => {
      if (error) {
        console.log(error);
      } else {
        const midiSource = WebMidi.getInputByName(this.source);
        const ccSource = WebMidi.getInputByName(this.ccSource);

        midiSource.addListener(
          "noteon",
          "all",
          this.handleNoteOn.bind(this)
        );
        midiSource.addListener(
          "noteoff",
          "all",
          this.handleNoteOff.bind(this)
        );

        midiSource.addListener(
          "controlchange",
          "all",
          this.handleControlChange.bind(this)
        );
      }
    });
  }

  handleControlChange(e) {
    console.log(
      `controller number: ${e.controller.number} value: ${e.value}`
    );
    if (e.controller.number === this.opacityCC) {
      this.opacity = scale(e.value, 0, 127, 0, 1);
    }
  }

  /* transition: opacity .5s ease-out;
    opacity: 0;
    */
  handleNoteOn(e) {
    if (e.note.number >= this.lowNote && e.note.number <= this.highNote) {
      console.log("note on:" + e.note.number);
      this.container = this.shadowRoot.querySelector("#container");
      const element = document.createElement("div");
      element.id = `note${e.note.number}`;
      const { note } = e;
      // const scaledVelocity = scale(e.velocity, 0, 1, 0, 127);
      note.velocity = e.velocity;
      // this.note = note;
      element.style = this.getNoteStyle(note);

      this.activeNotes.push(element);
      this.container.appendChild(element);

      if (this.transitionDuration !== "0s") {
        setTimeout(() => {
          element.style.opacity = "0";
        }, this.startFadeAfterMilliseconds);

        const removeTime =
          this.transitionDuration.slice(0, -1) * 1000 +
          this.startFadeAfterMilliseconds;
        setTimeout(() => {
          this.container.removeChild(element);
        }, removeTime);
      }

      if (this.noteCount >= this.numNotes - 1) {
        this.noteCount = 0;
      } else {
        this.noteCount += 1;
      }
    }
  }

  handleNoteOff(e) {
    console.log("note off:" + e.note.number);

    if (
      e.note.number >= this.lowNote &&
      e.note.number <= this.highNote &&
      this.transitionDuration === "0s"
    ) {
      const element = this.shadowRoot.querySelector(
        `#note${e.note.number}`
      );

      if (element) {
        //console.log('element removed');
        for (let i = 0; i < this.activeNotes.length; i++) {
          if (this.activeNotes[i].id === element.id) {
            this.activeNotes.splice(i, 1);
            break;
          }
        }
        this.container.removeChild(element);
      } else {
        console.log("no element to remove");
      }
    }
  }
  getNoteStyle(note) {
    let style = ``;

    const containerHeight = window
      .getComputedStyle(this.container)
      .height.slice(0, -2);
    const containerWidth = window
      .getComputedStyle(this.container)
      .width.slice(0, -2);

    const factor = scale(this.noteCount, 0, this.numNotes, 0, 1);
    const color = Color(this.startColor);
    const mixedColor = color.mix(Color(this.endColor), factor);

    if (this.orientation === "horizontal") {
      style = `
                position: absolute;
                ${this.startFrom}: ${(containerHeight / this.numNotes) * this.noteCount
        }px;
                width: ${containerWidth}px;
                height: ${containerHeight / this.numNotes}px;
                background: ${mixedColor};
                transition: opacity ${this.transitionDuration} ease;
                opacity: ${this.opacity};
            `;
    }

    if (this.orientation === "vertical") {
      style = `
                display: inline-block;
                position: absolute;
                ${this.startFrom}: ${(containerWidth / this.numNotes) * this.noteCount
        }px;
                width: ${containerWidth / this.numNotes};
                height: ${containerHeight};
                background: ${mixedColor};
                transition: opacity ${this.transitionDuration} ease;
                opacity: ${this.opacity};
            `;
    }

    if (this.orientation === "custom") {
      style = `
                display: inline-block;
                position: absolute;
                ${this.startFrom}: ${(containerWidth / this.numNotes) * this.noteCount
        }px;
                width: 0;
                height: 0;
                border-left: ${containerWidth / this.numNotes / 2
        }px solid transparent;
                border-right: ${containerWidth / this.numNotes / 2
        }px solid transparent;
                border-bottom: ${containerHeight}px solid ${mixedColor};
                transition: opacity ${this.transitionDuration} ease;
                opacity: ${this.opacity};
             `;
    }

    return style;
  }

  render() {
    if (WebMidi.supported) {
      return html`
                <style>
                    :host {
                      margin: 0 auto;
                    }
                    #container {
                      position: ${this.position};
                      display: inline-block;
                      width: ${this.width
          ? this.width
          : `calc(100% / ${this.widthDivision})`};

                      height: ${this.height
          ? this.height
          : `calc(100% / ${this.heightDivision})`};

                      left: ${this.left};
                      top: ${this.top};
                      background: ${this.backgroundColor};
                      opacity: ${this.backgroundOpacity};
                      mix-blend-mode: ${this.mixBlendMode};
                      box-shadow: ${this.boxShadow};
                      border-radius: ${this.borderRadius};
                      overflow: hidden;
                </style>
                <div id="container"></div>
            `;
    } else {
      return html``;
    }
  }
}

customElements.define("rhythmic-color", RhythmicColor);
